import moment from 'moment';
import EmptyCell from 'components/new-ui/base/emtpy-cell/EmptyCell';
import { Declaration } from 'store/declarations/declaration';

type Props = {
    declaration?: Declaration;
    dataTestId?: string;
};

const SubmittedBy = ({ declaration, dataTestId }: Props) => {
    const submittedBy = declaration?.submittedBy?.fullName;
    const submittedAt = declaration?.submittedAt;

    if (!submittedBy || !submittedAt) {
        return <EmptyCell dataTestId={dataTestId} />;
    }

    const formattedDate = moment(submittedAt).format('DD/MM/YY, HH:mm');

    return (
        <span data-testid={dataTestId}>
            <div>{submittedBy}</div>
            <div>{formattedDate}</div>
        </span>
    );
};

export default SubmittedBy;
